import React from "react";
import { useTranslation } from "react-i18next";
import {
  PassBooleanControl,
  PassSettingSwitch,
  PassSettingSwitchThumb,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const AutoAcceptAllGigsSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SystemSettingRow
      title={t("System.AutoAcceptTeamGigs")}
      description={t("System.AutoAcceptTeamGigsInfo")}
      controlVerticalAlign="center"
    >
      <PassBooleanControl>
        <PassSettingSwitch
          type="button"
          $active={value}
          aria-label={t("System.AutoAcceptTeamGigs")}
          aria-pressed={value}
          onClick={() => onChange(!value)}
        >
          <PassSettingSwitchThumb $active={value} />
        </PassSettingSwitch>
      </PassBooleanControl>
    </SystemSettingRow>
  );
};
